<template>
  <div class="p-3 flex">
    <slot />
  </div>
</template>



<script>
export default {
  name: "LToolbar"
};
</script>

